import axios from "./api";

const baseUrl = "/admin";

const Question = {
  // Get all existing questions
  // GET /admin/questions
  getAll(query = null) {
    return axios.get(`${baseUrl}/questions?${query ? query : ""}`);
  },

  // Get question by ID
  // GET /admin/questions/{id}
  getById(id) {
    return axios.get(`${baseUrl}/questions/${id}`);
  },

  // Get questions by location ID
  // GET /admin/questions/location/{locationId}
  getByLocationId(locationId) {
    return axios.get(`${baseUrl}/questions/location/${locationId}`);
  },

  // Create new questions (POST array of questions)
  // POST /admin/questions
  // Payload: [{ locationId: [1,2], question: "...", options: ["yes","no"], type: "radiobutton" }]
  create(data) {
    return axios.post(`${baseUrl}/questions`, data);
  },

  // Update existing question by ID
  // PUT /admin/questions/{id}
  // Payload: { locationIds: [1,3], question: "...", options: ["yes","no"], type: "checkbox" }
  update(id, data) {
    return axios.put(`${baseUrl}/questions/${id}`, data);
  },

  // Delete question by ID
  // DELETE /admin/questions/{id}
  delete(id) {
    return axios.delete(`${baseUrl}/questions/${id}`);
  },
};

export default Question;
